var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarningTriangle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "475px",
    height: "435px",
    viewBox: "-0.5 -0.5 475 435",
    content: "<mxfile host=\"app.diagrams.net\" modified=\"2021-02-04T15:57:14.354Z\" agent=\"5.0 (X11)\" etag=\"_7lLxVkg2k1YZAXm8wkq\" version=\"14.2.9\" type=\"device\"><diagram id=\"3oOmNzM9YNG-vHKGx90Z\" name=\"Page-1\">tZRbb4MgFIB/jY8uCm3V13btliXLmvShjwtRqmQoBrHqfv1Q8MJcs3bpfDCcj8Pt46gFN2n9xFGevLIIUws4UW3BRwuAlefJdwsaBaDnKhBzEik0AQfyiTV0NC1JhAsjUTBGBclNGLIsw6EwGOKcVWbaiVFz1RzFeAYOIaJzeiSRSBT1gTfyZ0zipF/ZXQWqJ0V9sj5JkaCIVRMEtxbccMaEaqX1BtPWXe9Fjdtd6B02xnEmrhlwDtcZeLH39n7/7hybErwlvq1nOSNa6gPrzYqmNyA4QVncRusqIQIfchS2XZW8b8kSkVIZubLJmUCCsEyGduBIUAjOPgZvfpdSZhGO9IAToXTDKOPdSnAnnyCQXG8Kc4Hri6d1B4ey9jBLseCNTNEDoK+193UHliquxlt0HZ2TGDeoIdKVEw9zj3JlQ/u9wTX43bWcRRb2FapRkatqP5G61flNrCkezlU73XMf1YterVa96A0aqn8w/V+i4X2L+m9iJx9DcC/RjvdgqoYeeJjX9WI5lw1uly3D8e/U9U1+8XD7BQ==</diagram></mxfile>",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 36 216 L 36 36 Q 36 -4 71.05 15.28 L 400.95 196.72 Q 436 216 400.95 235.28 L 71.05 416.72 Q 36 436 36 396 Z",
    fill: "#ffff99",
    stroke: "#000000",
    strokeWidth: 32,
    strokeMiterlimit: 10,
    transform: "rotate(-90,236,216)",
    pointerEvents: "all"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 236,
    cy: 356,
    rx: 20,
    ry: 20,
    fill: "#000000",
    stroke: "#000000",
    strokeWidth: 12,
    pointerEvents: "all"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 146 226 L 146 206 Q 146 186 185.05 194.68 L 286.95 217.32 Q 326 226 286.95 234.68 L 185.05 257.32 Q 146 266 146 246 Z",
    fill: "#000000",
    stroke: "#000000",
    strokeWidth: 12,
    strokeMiterlimit: 10,
    transform: "rotate(90,236,226)",
    pointerEvents: "all"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningTriangle);
export default __webpack_public_path__ + "static/media/warningTriangle.4988f45279a7d8a8ba9414d59348a3e5.svg";
export { ForwardRef as ReactComponent };